import PropTypes from 'prop-types'
import React from 'react'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { useFormikContext } from 'formik'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { Header } from 'SRC/modules/ads/shared/components/FormElements'

const List = ({ packages }) => {
  const formik = useFormikContext()

  if (!formik) return null

  return (
    <React.Fragment>
      <Header title='Izaberi tip oglasa' key='promoPeriods-header' />

      <div className='tipovi-oglasa' key='promoPeriods-list'>
        {
          packages.map(item =>
            <Item
              {...item}
              key={`type-${item.id}`}
              isActive={formik.values.listing === item.id}
              onClick={event => {
                const value = Number(event.target.dataset.id)
                console.log('value', value)
                formik.setFieldValue('listing', value)
              }}
            />
          )
        }
      </div>
    </React.Fragment>
  )
}

List.propTypes = {
  change: PropTypes.func.isRequired,
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  }))
}

List.displayName = 'PromoPeriods'

const mapStateToProps = (state, ownProps) => {
  const category = getCurrentSubCategory(state)
  let packages = []

  const categoryPackages = category && Array.isArray(category.listings)

  if (categoryPackages) packages = category.listings

  return {
    packages
  }
}

export default connect(mapStateToProps)(List)
